import { useState } from "react";
import { useNotification } from "../../../context/NotificationContext";
import expedientesService from "../../../services/expedientesService";

// Material Dashboard 2 React components
import { Card, CardActions, CardContent, CardHeader } from "@mui/material";
import MDBox from "components/MDBox";
import Grid from "@mui/material/Grid";
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "navbars/DashboardNavbar";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import ImportData from "./importData"
import { DateFormat } from "services/common";

const NewFile = () => {
  const { showNotification } = useNotification();  
  const dateNow = DateFormat(Date.now());
  const [numero, setNumero] = useState("");
  const [anio, setAnio] = useState("");
  const [cuaderno, setCuaderno] = useState("");
  const [caratula, setCaratula] = useState("");
  const [jurisdiccion, setJurisdiccion] = useState("");
  const [dependencia, setDependencia] = useState("");
  const [sorteo, setSorteo] = useState(dateNow);
  const [notificacion, setNotificacion] = useState(dateNow);
  const [aceptacion, setAceptacion] = useState(dateNow);
  const [linkExpediente, setLinkExpediente] = useState("");
  const [linkRepositorio, setLinkRepositorio] = useState("");
  const [importDataKey, setImportDataKey] = useState(Date.now());
  const [submitting, setSubmitting] = useState(false);

  function clearForm() {
    const today = DateFormat(Date.now());
    setNumero("");
    setAnio("");
    setCuaderno("");
    setCaratula("");
    setJurisdiccion("");
    setDependencia("");
    setSorteo(today);
    setNotificacion(today);
    setAceptacion(today);
    setLinkExpediente("");
    setLinkRepositorio("");
    setImportDataKey(Date.now());
  }

  const addExpediente = async () => {
    setSubmitting(true);
    try {
      const response = await expedientesService.createExpediente({
        numero,
        anio,
        caratula,
        cuaderno,
        jurisdiccion,
        dependencia,
        fecha_sorteo: sorteo,
        fecha_notificacion: notificacion,
        fecha_aceptacion: aceptacion,
        linkExpediente,
        linkRepositorio,
      });
      if (response.success && response.id) {
        showNotification("Registro agregado correctamente", "success", "", {
          name: "Ver expediente nuevo",
          link: `/file/detail/${response.id}`,
        });
        clearForm();
      } else if (response.success) {
        showNotification("Registro agregado correctamente", "success");
        clearForm();
      } else {
        showNotification(response.error, "error");
      }
    } catch {
      showNotification("Error al guardar el expediente", "error");
    } finally {
      setSubmitting(false);
    }
  };

  const handleExpedienteParsed = (data) => {
    try {
      setNumero(data.numero);
      setAnio(data.anio);
      setCaratula(data.caratula);
      setCuaderno(data.cuaderno);
      setJurisdiccion(data.jurisdiccion);
      setDependencia(data.dependencia);
    } catch (error) {
      showNotification(error.message, "error")
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar title="Nuevo expediente" />
      <Card>
        <CardHeader title="Nuevo expediente" />
        <CardContent>
          <MDBox pb={2}>
            <ImportData key={importDataKey} onExpedienteParsed={handleExpedienteParsed} />
          </MDBox>

          <Grid container spacing={2}>
            {/* ...inputs... */}
            <Grid item xs={4}>
              <MDInput fullWidth type="number" label="Número" value={numero} onChange={(event) => setNumero(event.target.value)} />
            </Grid>
            <Grid item xs={4}>
              <MDInput fullWidth type="number" label="Año" value={anio} onChange={(event) => setAnio(event.target.value)} />
            </Grid>
            <Grid item xs={4}>
              <MDInput fullWidth type="number" label="Cuaderno" value={cuaderno} onChange={(event) => setCuaderno(event.target.value)} />
            </Grid>
            <Grid item xs={12}>
              <MDInput fullWidth type="text" label="Carátula" value={caratula} onChange={(event) => setCaratula(event.target.value)} />
            </Grid>
            <Grid item xs={12}>
              <MDInput fullWidth type="text" label="Jurisdicción" value={jurisdiccion} onChange={(event) => setJurisdiccion(event.target.value)} />
            </Grid>
            <Grid item xs={12}>
              <MDInput fullWidth type="text" label="Dependencia" value={dependencia} onChange={(event) => setDependencia(event.target.value)} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <MDInput fullWidth type="date" label="Fecha sorteo" value={sorteo} onChange={(event) => setSorteo(event.target.value)} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <MDInput fullWidth type="date" label="Fecha notificación" value={notificacion} onChange={(event) => setNotificacion(event.target.value)} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <MDInput fullWidth type="date" label="Fecha aceptación" value={aceptacion} onChange={(event) => setAceptacion(event.target.value)} />
            </Grid>
            <Grid item xs={12}>
              <MDInput fullWidth type="text" label="Link a expediente del juzgado" value={linkExpediente} onChange={(event) => setLinkExpediente(event.target.value)} />
            </Grid>
            <Grid item xs={12}>
              <MDInput fullWidth type="text" label="Link a respositorio de archivos" value={linkRepositorio} onChange={(event) => setLinkRepositorio(event.target.value)} />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <MDButton variant="gradient" color="success" onClick={addExpediente} disabled={submitting}>
            Guardar
          </MDButton>
          <MDButton variant="gradient" color="secondary" onClick={clearForm}>
            Limpiar
          </MDButton>
        </CardActions>
      </Card>
    </DashboardLayout>
  );
};

export default NewFile;
